import { render, staticRenderFns } from "./ConsumptionsDistributionChart.vue?vue&type=template&id=a500aee8&"
import script from "./ConsumptionsDistributionChart.vue?vue&type=script&lang=ts&"
export * from "./ConsumptionsDistributionChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports